import PropTypes from "prop-types";
import Skeleton from "@mui/material/Skeleton";

const SkeletonAnimation = ({ variant, width, height, animation, sx }) => {
  return (
    <Skeleton
      variant={variant}
      width={width}
      height={height}
      animation={animation}
      sx={sx}
    />
  );
};

SkeletonAnimation.propTypes = {
  variant: PropTypes.oneOf(["text", "circular", "rectangular", "rounded"]), // Acceptable variants
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // Width in px or %
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // Height in px or %
  animation: PropTypes.oneOf(["wave", "pulse", false]), // Animation type
  sx: PropTypes.object, // MUI custom styles
};

export default SkeletonAnimation;
